import { ApiPaths } from "../helpers/api";
import { TimKiemNhanVienRequest } from "../models/nhanvien/NhanVien";
import intance from "../utils/axios";

export const xuatBaoCaoTongHopLuong = async (thang: number, nam: number, loai: number) => {
    var rs: any;
    await intance.post(ApiPaths.baoCao.tongHopLuong, {       
        "thang": thang,
        "nam": nam,
        "loai": loai
    },
        { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatBaoCaoNhanVien = async (request: TimKiemNhanVienRequest) => {
    var rs: any;
    await intance.post(ApiPaths.baoCao.baoCaoNhanVien, {
        "idDonVi": request.idDonVi,
        "tuKhoa": request.tuKhoa || "",
        "idChucVu": request.idChucVu,
        "ngaySinh": request.ngaySinh || "",
        "idHocHam": request.idHocHam,
        "idNhomNhanSu": request.idNhomNhanSu,
        "maNhanVien": request.maNhanVien || "",
        "soDienThoai": request.soDienThoai || "",
        "ten": request.ten || "",
        "email": request.email || "",
        "idChucDanh": request.idChucDanh,
        "gioiTinh": request.gioiTinh,
        "isKetHon": request.isKetHon,
        "idTrinhDoLLCT": request.idTrinhDoLLCT,
        "isDangVien": request.isDangVien,
        "isQuanNhan": request.isQuanNhan,
        "ngayVaoLam_TuNgay": request.ngayVaoLam_TuNgay || null,
        "ngayVaoLam_DenNgay": request.ngayVaoLam_DenNgay || null,
        "idLoaiQuyetDinh": request.idLoaiQuyetDinh || null,
        "ngayBatDauQTLV_TuNgay": request.ngayBatDauQTLV_TuNgay || null,
        "ngayBatDauQTLV_DenNgay": request.ngayBatDauQTLV_DenNgay || null,
        "ngayKetThucQTLV_TuNgay": request.ngayKetThucQTLV_TuNgay || null,
        "ngayKetThucQTLV_DenNgay": request.ngayKetThucQTLV_DenNgay || null,
        "daoTao_NgayBatDau_TuNgay": request.daoTao_NgayBatDau_TuNgay || null,
        "daoTao_NgayBatDau_DenNgay": request.daoTao_NgayBatDau_DenNgay || null,
        "daoTao_NgayKetThuc_TuNgay": request.daoTao_NgayKetThuc_TuNgay || null,
        "daoTao_NgayKetThuc_DenNgay": request.daoTao_NgayKetThuc_DenNgay || null,
        "daoTao_Ten": request.daoTao_Ten || "",
        "chungChi_NgayBatDau_TuNgay": request.chungChi_NgayBatDau_TuNgay || null,
        "chungChi_NgayBatDau_DenNgay": request.chungChi_NgayBatDau_DenNgay || null,
        "chungChi_NgayKetThuc_TuNgay": request.chungChi_NgayKetThuc_TuNgay || null,
        "chungChi_NgayKetThuc_DenNgay": request.chungChi_NgayKetThuc_DenNgay || null,
        "chungChi_Ten": request.chungChi_Ten || "",
        "danhGia_Nam": request.danhGia_Nam || null,
        "danhGia_KetQua": request.danhGia_KetQua || null,
        "khenThuong_ThanhTich": request.khenThuong_ThanhTich || "",
        "khenThuong_NgayQuyetDinh_TuNgay": request.khenThuong_NgayQuyetDinh_TuNgay || null,
        "khenThuong_NgayQuyetDinh_DenNgay": request.khenThuong_NgayQuyetDinh_DenNgay || null,
        "kyLuat_NoiDung": request.kyLuat_NoiDung || "",
        "kyLuat_NgayQuyetDinh_TuNgay": request.kyLuat_NgayQuyetDinh_TuNgay || null,
        "kyLuat_NgayQuyetDinh_DenNgay": request.kyLuat_NgayQuyetDinh_DenNgay || null,
        "selectedColumns": request.selectedColumns || null,
        "trangThai": request.trangThai !== undefined ? request.trangThai : null,
        "tenChuyenNganhDaoTao": request.tenChuyenNganhDaoTao || "",
    },
        { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatBaoCaoPhepNam = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.baoCao.baoCaoPhepNam, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatBaoCaoDaoTao = async (tuKhoa: string) => {
    var rs: any;
    await intance.post(ApiPaths.baoCao.baoCaoDaoTao, {
        "tuKhoa": tuKhoa
    },
        { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
}; 

export const xuatBaoCaoTongHopKPI = async (request: any) => {
    var rs: any;
    await intance.post(ApiPaths.baoCao.baoCaoTongHopKPI, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatDanhGiaKetQuaKPI = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.danhGiaKetQuaKPI + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatDonNghiPhep = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.donNghiPhep + "?id=" + id,
        { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};

export const xuatDonNgoaiGio = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.donNgoaiGio + "?id=" + id,
        { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};
export const xuatBaoCaoChiTietNhanVienMoi = async (id: number, loaiMau: number = 1) => {
    var rs: any;
    await intance.get(ApiPaths.baoCao.baoCaoCTNhanVienMoi + "?idNhanVien=" + id + "&loaiMau=" + loaiMau,
        { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch((err) => {
            throw 'Có lỗi xảy ra. Vui lòng thử lại';
        });
    return rs;
};